import { TFunction } from 'i18next';

import { EncumbrancesExcelValidationError } from '../types/EncumbrancesExcel';

export const getEncumbrancesExcelValidationMessages = (
  errors: EncumbrancesExcelValidationError[],
  t: TFunction
): string[] =>
  errors.map((error) => {
    const baseKey = `EncumbrancesExcelError_${error.code}`;
    return t(baseKey, {
      encumbranceId: error.encumbranceId || '',
      rowIndex: error.rowIndex || '',
      cif: error.cif || '',
      detail: error.detail || '',
    });
  });
